export default (pDate) => {
  if (!pDate) return '--/--/----'
  const diffFromNow = new Date() - new Date(pDate)
  const diffInDays = Math.floor(diffFromNow / 1000 / 60 / 60 / 24)
  const diff = dateRange(diffInDays)
  const time = diffInDays < 0 ? 'Daqui' : diffInDays < 3 ? '' : 'Há'
  return `${time} ${diff}`
}

const dateRange = (pDiffDate) => {
  const diff = Math.abs(pDiffDate)
  if (diff === 0) return 'Hoje'
  if (diff === 1) return 'Ontem'
  if (diff === 2) return 'Anteontem'
  if (diff <= 6) return `${diff} dia${diff > 1 ? 's' : ''}`
  if (diff > 6 && diff <= 29) return `${Math.floor(diff / 7)} semana${Math.floor(diff / 7) > 1 ? 's' : ''}`
  if (diff > 29 && diff <= 365) return `${Math.floor(diff / 30)} mes${Math.floor(diff / 30) > 1 ? 'es' : ''}`
  if (diff > 365) return `${Math.floor(diff / 365)} ano${Math.floor(diff / 365) > 1 ? 's' : ''}`

  return ''
}



// WEBPACK FOOTER //
// ./src/components/primitives/helpers/filters/FriendlyDate.js